@if (true) {
  <app-loading-screen></app-loading-screen>
}
